module.exports = __webpack_public_path__ + "img/symbol_0.9c0734b4.png";